module.exports = __webpack_public_path__ + "img/1531910557.0e18a96a.jpg";